import { Copy } from 'lucide-react';

interface Version {
  id: string;
  version: string;
  status: string;
  created_at: string;
}

interface VersionSelectorProps {
  versions: Version[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onClone: (id: string) => void;
}

function formatVersionDate(iso: string): string {
  try {
    return new Date(iso).toLocaleString('zh-CN', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export default function VersionSelector({ versions, activeId, onSelect, onClone }: VersionSelectorProps) {
  return (
    <div className="version-selector">
      <h4>版本</h4>
      <ul className="version-list">
        {versions.map((v) => (
          <li
            key={v.id}
            className={`version-item ${v.id === activeId ? 'active' : ''} ${v.status}`}
            onClick={() => onSelect(v.id)}
          >
            <span className="version-label">{v.version || '未命名版本'}</span>
            <span className="version-status">{v.status === 'active' ? '已激活' : v.status}</span>
            <span className="version-date">{formatVersionDate(v.created_at)}</span>
            <button
              className="clone-btn"
              onClick={(e) => { e.stopPropagation(); onClone(v.id); }}
              title="克隆"
            >
              <Copy size={14} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
